module.exports = __webpack_public_path__ + "static/img/u168.d7d1939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u168.png
// module id = 1coR
// module chunks = 0